import { Context } from "urql";
import { publicConfig } from "@lululemon/ecom-core";
import { KIWI_PATH } from "./util/constants";
import { Logger } from "../utils/logger";

const featuredPdpCategoryDetailsQuery = `
query SeoFeaturedCategoryPDP($productId: String!, $locale: String!, $limit: Int!) {
  seoFeaturedCategoryPDP(productId: $productId, locale: $locale, limit: $limit) {
    id
    locale
    relatedUrls {
      id
      baseKeyword
      rank
      recUrlKeyword
      basePageUrl
      recPageUrl
    }
  }
}
`;

const defaultFeaturedCategoryResponse = {
  seoFeaturedCategoryPDP: {
    id: null,
    locale: null,
    relatedUrls: [],
  },
};

export const fetchPdpFeaturedCategoryDetails = async (
  params = {},
  graphqlClient,
  isSeoPdpFeaturedCategoriesEnabled = false
) => {
  if (
    !isSeoPdpFeaturedCategoriesEnabled ||
    params?.locale?.toLowerCase() === "fr_ca" ||
    params?.productId == null
  ) {
    return defaultFeaturedCategoryResponse;
  }

  try {
    const { productId, locale, limit } = params;
    const apiHost = `${publicConfig?.apiHost}`;
    Context.url = `${apiHost}${KIWI_PATH}`;

    const { data, error } = await graphqlClient
      .query(
        featuredPdpCategoryDetailsQuery,
        { productId, locale, limit },
        Context
      )
      .toPromise();

    if (error) {
      throw error;
    }
    return data?.seoFeaturedCategoryPDP;
  } catch (error) {
    Logger.error("Error fetching PDP Featured Categories", {
      cause: error,
      functionName: "graphql.seoFeaturedCategoryPDP",
    });

    return defaultFeaturedCategoryResponse;
  }
};

export default fetchPdpFeaturedCategoryDetails;
